import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appFocusInvalidInput]'
})
export class FocusInvalidInputDirective {

  constructor(private elementRef: ElementRef) { }

  @HostListener('submit')
  onFormSubmit() {
    const invalidControl = this.elementRef.nativeElement.querySelector('.ng-invalid');

    if (invalidControl) {
      invalidControl.focus();
    }
  }
}
